var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconMetaMask = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_MetaMask")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.0\\u6539\\u7248",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trading-Account_\\u7F51\\u7EDC\\u663E\\u793A",
    transform: "translate(-824.000000, -15.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_MetaMask",
    transform: "translate(824.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#EEEEEE",
    strokeWidth: 0.875,
    fill: "#FFD4A0",
    cx: 14,
    cy: 14,
    r: 13.5625
  }), /*#__PURE__*/React.createElement("g", {
    id: "MetaMask",
    transform: "translate(5.338115, 5.833333)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E17726",
    points: "10.9575185 2.09666663 9.69931819 5.10457121 16.4669682 1.69177292e-06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "7.56404193 5.15209311 6.3652381 2.09617601 0.856284097 1.69177292e-06"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "12.2295795 14.639065 16.0853499 15.721057 17.18912 11.896466 14.0302586 11.8350905"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "0.140569412 11.8964812 1.23790577 15.7210723 5.08724746 14.6390803 3.29349446 11.835102"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "4.87985809 7.09829177 3.80875436 8.74602784 7.62393915 8.92322583 7.49673322 4.73781345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "12.4434026 7.09829177 9.78593189 4.68929171 9.69931312 8.9227166 13.5149885 8.74551861"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "5.08723561 14.639065 7.3967425 13.5026267 5.40896007 11.92369"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27625",
    points: "9.92700884 13.5026335 12.2295795 14.6390718 11.9147828 11.9236917"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#D5BFB2",
    points: "12.2295795 14.639065 9.92700884 13.5026267 10.1146011 15.0271172 10.0943076 15.6740359"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#D5BFB2",
    points: "5.08723561 14.639065 7.22895246 15.6735402 7.21558842 15.0271172 7.39674516 13.5026267"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#233447",
    points: "7.2695381 10.9164372 5.35551696 10.3452489 6.70726552 9.71169521"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#233447",
    points: "10.0542132 10.9164372 10.6159986 9.71169351 11.9756663 10.3452472"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#CC6228",
    points: "5.08723561 14.639065 5.42183108 11.8350868 3.29347924 11.8964623"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#CC6228",
    points: "11.9014263 11.8351037 12.2295879 14.6395726 14.0302603 11.8964812"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#CC6228",
    points: "13.5150054 8.74553722 9.69882251 8.92223952 10.0542065 10.9169413 10.6164858 9.71170366 11.9751639 10.3447634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#CC6228",
    points: "5.35502635 10.3447532 6.70726891 9.71169351 7.26905425 10.9164372 7.62443822 8.9227166 3.80876282 8.74551861"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27525",
    points: "3.8087459 8.74553722 5.40847115 11.9232112 5.35501502 10.3447702"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27525",
    points: "11.9751706 10.3447532 11.914785 11.92369 13.5150043 8.74552538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27525",
    points: "7.62443822 8.92222599 7.26905425 10.9169278 7.71798649 13.270979 7.81846427 10.167557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#E27525",
    points: "9.69933004 8.92222599 9.5117378 10.1611214 9.60578109 13.2709892 10.0537236 10.9164473"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F5841F",
    points: "10.0542132 10.9164372 9.60577499 13.270979 9.92700715 13.5026217 11.9152802 11.9236849 11.9756658 10.3447482"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F5841F",
    points: "5.35502635 10.3447532 5.40848248 11.92369 7.39626491 13.5026267 7.71799106 13.2714781 7.26905882 10.9164456"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#C0AC9D",
    points: "10.0943083 15.674041 10.1146018 15.0271222 9.93987883 14.8776429 7.38339001 14.8776429 7.21609211 15.0271222 7.22945615 15.674041 5.08724869 14.6395658 5.83712027 15.2652004 7.35616656 16.3333333 9.96066789 16.3333333 11.4866437 15.2652004 12.2300798 14.6390701"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#161616",
    points: "9.92700884 13.5026335 9.60528269 13.2709909 7.71799157 13.2709909 7.39626542 13.5026335 7.21560268 15.0271239 7.38290058 14.8771498 9.94038755 14.8771498 10.1146148 15.0266291"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#763E1A",
    points: "9.92651822 4.93431118 12.4439102 7.09878238 15.998748 8.15305635 16.780792 7.22103835 16.4402568 6.96860722 16.9822433 6.46572264 16.5674629 6.13904637 17.1094494 5.71684244 16.7550551 5.43768299 17.3237699 2.6198491 16.4669868 0.000493997693"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#763E1A",
    points: "0 2.62033802 0.575644346 5.43817191 0.207391059 5.71683737 0.756801083 6.13904129 0.341030969 6.46571757 0.883017493 6.96909614 0.541986524 7.22152727 1.32551593 8.15354528 4.87986317 7.0992713 7.39676449 4.93429258 0.856302707 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F5841F",
    points: "13.5145148 8.74553722 11.9152853 11.9241924 14.0302721 11.8964744 17.1896242 11.8964744 15.9982456 8.15305466 12.4438983 7.09878069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F5841F",
    points: "1.32551424 8.15306143 0.141065102 11.8964812 3.29398846 11.8964812 5.40848468 11.9237042 3.80875943 8.74603021 4.87986317 7.09878813"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F5841F",
    points: "9.69933004 8.92222599 9.92701391 4.93429427 10.9575303 2.09617601 6.3662447 2.09617601 7.39676111 4.93429427 7.62444499 8.92222599 7.71155877 10.1744865 7.71799331 13.2709892 9.60528443 13.2709892 9.61221393 10.1744865"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMetaMask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_MetaMask.44e43f2e.svg";
export { ForwardRef as ReactComponent };